module.exports = __webpack_public_path__ + "img/9 filters-06.da87f4a5.svg";